// REACT
import { memo } from "react";

// MATERIAL UI
import { Grid, Link, Typography, Divider } from "@mui/material";

// COMPONENTS
import CountryFlag from "src/utils/CountryFlag";

// ICONS
import ClosedEye from "src/icons/ClosedEye";
import OpenEye from "src/icons/OpenEye";

// STYLES
import { PaymentStyles } from "./Payment.styles";

// REDUX
import { IBankDetailsRes } from "src/store/features/api/generated";

interface IBankAccount extends IBankDetailsRes {
  isOpen: boolean;
}

const AccountList = memo(
  ({
    accounts,
    toggleVisibility,
  }: {
    accounts: IBankAccount[];
    toggleVisibility: (index: number) => void;
  }): JSX.Element => {
    const classes = PaymentStyles();

    return (
      <>
        {accounts.map((bankAccount: IBankAccount, i: number) => (
          <Grid key={i}>
            <Grid
              container
              item
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              marginY="16px">
              <Grid display="flex" flexDirection="row" alignItems="center">
                <div style={{ paddingRight: "16px" }}>
                  <CountryFlag
                    countrycode={bankAccount?.currency?.slice(0, 2).toLowerCase()}
                    size={36}
                  />
                </div>
                <Grid container spacing={0.75}>
                  <Grid item>
                    <Typography className={classes.bankManagementSubHeader}>
                      {bankAccount.currency}
                    </Typography>
                  </Grid>
                  <Grid item container alignItems="center">
                    <Grid item display="flex">
                      <Typography color="#5C6469" fontSize="14px">
                        Bank Account Ending in{" "}
                        <span className={classes.accountNumberContainer}>
                          {bankAccount.isOpen ? bankAccount.trailingAccNumberDigits : "****"}
                        </span>
                      </Typography>
                      <div style={{ display: "flex", alignSelf: "center", margin: "0 6px" }}>
                        <Link className={classes.eyeIconLink} onClick={() => toggleVisibility(i)}>
                          {bankAccount.isOpen ? (
                            <OpenEye width={22} height={16} />
                          ) : (
                            <ClosedEye width={22} height={16} />
                          )}
                        </Link>
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Divider />
          </Grid>
        ))}
      </>
    );
  },
);

export { AccountList };
